import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_UnresolvedCode = {
    _v1: {
        createUnresolvedCodes: { method: HttpMethod.POST, path: '/v1/create-unresolved-codes' },
        getAllUnresolvedCodes: { method: HttpMethod.GET, path: '/v1/get-all-unresolved-codes' }
    }
};
//# sourceMappingURL=api-def.js.map